import { DatePipe, DecimalPipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { NotificationsService } from 'bowman-angular2-notifications';
import { BowmanCacheService } from 'bowman-cache';
import { CrudActionType, HelperFunctions, TrimPipe } from 'bowman-commons';
import Drawflow from 'node_modules/bowman-drawflow/drawflow.min.js';
import { DrawFlowDto, DrawFlowNode } from '../data-types/flow-management/model/drawflow-dto';
import { StepQueryResultContainer } from '../data-types/flow-management/model/step-query-result-container';
import { TimestampFormatPipe } from '../timestamp-format.pipe';
import { UserResponse } from 'algorilla-shared-libs';

@Component({
  selector: 'app-drawflow-graph',
  templateUrl: './drawflow-graph.component.html',
  styleUrls: ['./drawflow-graph.component.scss']
})
export class DrawflowGraphComponent implements OnInit, AfterViewInit {
  public drawflowId: string = HelperFunctions.uuid();
  @ViewChild('drawflow') drawFlowHtmlElement: ElementRef;
  @Input() public edit: boolean = false;
  @Input() public drawFlowData: DrawFlowDto;
  @Input() public closureSteps: string[] = [];
  @Input() public selectedStep: DrawFlowNode;
  @Input() public inspectData: StepQueryResultContainer = null;
  @Input() public showInspectStats: boolean = false;
  @Input() public rawInspectData: Record<string, number> = {};

  @Output() public stepEmitted: EventEmitter<DrawFlowNode> = new EventEmitter<DrawFlowNode>();
  @Output() public flowEmitted: EventEmitter<DrawFlowDto> = new EventEmitter<DrawFlowDto>();

  @Input() action: CrudActionType;
  public clickedOnGraph: boolean = false;
  public crudActionTypes = CrudActionType;
  public user: UserResponse;
  locked: boolean = true;
  editor!: any;
  flowData: any;
  nodePositions: Record<string, { pos_x: number, pos_y: number }> = {};

  constructor(
    private _trimPipe: TrimPipe,
    private _decimalPipe: DecimalPipe,
    private _timestampFormatPipe: TimestampFormatPipe,
    private _datePipe: DatePipe,
    private _bowmanCacheService: BowmanCacheService,
    private _notificationsService: NotificationsService) { }

  @HostListener('wheel', ['$event'])
  onScroll(event) {
    event.preventDefault();
    if (event.wheelDeltaY > 0) {
      this.editor.zoom_in();
    }
    if (event.wheelDeltaY < 0) {
      this.editor.zoom_out();
    }
  }
  onZoomOut() {
    this.editor.zoom_out();
    //this.editor.translate_to(this.editor.canvas_x * 0.9, this.editor.canvas_y * 0.9);
  }

  onZoomIn() {
    this.editor.zoom_in();
    //this.editor.translate_to(this.editor.canvas_x * 1.1, this.editor.canvas_y * 1.1);
  }

  onZoomReset() {
    this.editor.zoom_reset();

    /*  var drawFlowHtmlElement = document.getElementById('drawflow-' + this.drawflowId);
     let width: number = document.getElementById('drawflow-' + this.drawflowId).parentElement.parentElement.offsetWidth;
     let height: number = document.getElementById('drawflow-' + this.drawflowId).parentElement.parentElement.offsetHeight;
     let defaultBlockWidth: number = 225;
     let defaultBlockHeight: number = 125;
     let allPosX: number[] = [defaultBlockWidth];
     let allPosY: number[] = [defaultBlockHeight];
     Object.keys(this.flowData.drawflow.Home.data).map(stepId => {
       let stepBlock = this.flowData.drawflow.Home.data[stepId];
       allPosX.push(stepBlock.pos_x + defaultBlockWidth);
       allPosY.push(stepBlock.pos_y + defaultBlockHeight);
     });
     let maxPosX: number = allPosX.sort((a, b) => a - b)[allPosX.length - 1];
     let maxPosY: number = allPosY.sort((a, b) => a - b).sort()[allPosY.length - 1];
     let percentage: number = (100-((maxPosX*100)/width))/100;
     this.editor.zoom = 1+percentage;
     console.log(width, height); */
    this.editor.translate_to(-675, -675);
  }

  get getWidth() {
    return `${Object.keys(this.drawFlowData).length * 500}px`;
  }

  export() {
    debugger
    const html = JSON.stringify(this.editor.export(), null, 4)
  }

  onClear() {
    this.editor.clear();
  }

  private initDrawFlow(): void {
    if (typeof document !== 'undefined') {
      const drawFlowHtmlElement = document.getElementById('drawflow-' + this.drawflowId);
      this.editor = new Drawflow(drawFlowHtmlElement as HTMLElement);
      this.editor.start();
      this.editor.createCurvature = function (start_pos_x: any, start_pos_y: any, end_pos_x: any, end_pos_y: any, curvature_value: any, type: any) {
        var line_x = start_pos_x; var line_y = start_pos_y; var x = end_pos_x; var y = end_pos_y; var curvature = curvature_value;
        switch (type) { default: var hx1 = line_x + Math.abs(x - line_x) * curvature; var hx2 = x - Math.abs(x - line_x) * curvature; let xx = ' M ' + line_x + ' ' + line_y + ' C ' + hx1 + ' ' + line_y + ' ' + (hx2) + ' ' + y + ' ' + (x - 20) + '  ' + y + ' M ' + (x - 11) + ' ' + y + ' L' + (x - 20) + ' ' + (y - 5) + '  L' + (x - 20) + ' ' + (y + 5) + 'Z'; return xx; }
      }
      this.editor.createCurvature = function (start_pos_x: any, start_pos_y: any, end_pos_x: any, end_pos_y: any, curvature_value: any, type: any) {
        var line_x = start_pos_x;
        var line_y = start_pos_y;
        var x = end_pos_x;
        var y = end_pos_y;
        var curvature = curvature_value;
        switch (type) {
          default:
            var hx1 = line_x + Math.abs(x - line_x) * curvature;
            var hx2 = x - Math.abs(x - line_x) * curvature;
            return ' M ' + line_x + ' ' + line_y + ' C ' + hx1 + ' ' + line_y + ' ' + hx2 + ' ' + y + ' ' + (x - 21) + '  ' + y + ' M ' + (x - 11) + ' ' + y + ' L' + (x - 20) + ' ' + (y - 5) + '  L' + (x - 20) + ' ' + (y + 5) + ' Z' + ' M ' + (x - 11) + ' ' + y + ' L' + (x - 20) + ' ' + (y - 3) + '  L' + (x - 20) + ' ' + (y + 3) + ' Z' + ' M ' + (x - 11) + ' ' + y + ' L' + (x - 20) + ' ' + (y - 1) + '  L' + (x - 20) + ' ' + (y + 1) + ' Z';
        }
      }
      this.editor.translate_to = function (x, y) {
        this.canvas_x = x;
        this.canvas_y = y;
        let storedZoom = this.zoom;
        this.zoom = 1;
        this.precanvas.style.transform = "translate(" + this.canvas_x + "px, " + this.canvas_y + "px) scale(" + this.zoom + ")";
        this.zoom = storedZoom;
        this.zoom_last_value = 1;
        this.zoom_refresh();
      }
    }
  }

  public initializeDrawflow(tmpDrawFlowData: DrawFlowDto) {
    // Itera attraverso le chiavi dell'oggetto steps
    for (const key in tmpDrawFlowData) {
      const step = tmpDrawFlowData[key];
      const nodeId = key;

      let nodeClass = 'dbclick';
      if (this.closureSteps) {
        if (this.closureSteps.includes(step.data.code)) {
          nodeClass = 'step-closure';
        }
      } else if (this.selectedStep != null && this.selectedStep.id == step.id) {
        nodeClass = 'selected';
      }

      tmpDrawFlowData[nodeId].class = nodeClass;

      let html = '<div><div class="title-box">' + step.data.name + ' </div>';
      html += '<div class="box">' + (step.data.description != null && step.data.description.trim() != '' ? this._trimPipe.transform(step.data.description, 60) : '') + '</div>';
      html += '</div>';
      tmpDrawFlowData[nodeId].html = html;


      if (this.inspectData != null && this.inspectData.instanceDuration) {
        // Comincio modificando l'html e aggiungendo l'eventuale counter
        let parsedDate: string[] = null;
        if (this.action == CrudActionType.TEST) {
          if (this.rawInspectData && this.rawInspectData[step.data.code]) {
            parsedDate = [];
            parsedDate[0] = (this._datePipe.transform(this.rawInspectData[step.data.code], this.user.options['dateFormat'], this.user.options['timeZone'] != 'Client default' ? this.user.options['timeZone'] : null)).split(' - ')[0];
            parsedDate[1] = (this._datePipe.transform(this.rawInspectData[step.data.code], this.user.options['dateFormat'], this.user.options['timeZone'] != 'Client default' ? this.user.options['timeZone'] : null)).split(' - ')[1];
          }
        }
        if (this.inspectData.stepCounters && this.inspectData.stepCounters.hasOwnProperty(step.data.code)) {
          let counterValue = this.inspectData.stepCounters[step.data.code];

          let html = '<div><div class="title-box">' + step.data.name + ' </div>';

          html += `<div class="box-counter"> ${(parsedDate != null ? `<p>${parsedDate[0]}<br/><small>${parsedDate[1]}</small></p>` : `<p>${this._decimalPipe.transform(counterValue, null)}</p>`)}
          ${step.data.maxDurationSecs ? `<span class="badge badge-timeout float-right"><i class="mio vam mr-1">schedule</i>${this._timestampFormatPipe.transform(parseFloat((step.data.maxDurationSecs * 1000).toFixed(2)), 0)}` : `<span class="badge badge-timeout float-right"><i class="mio vam mr-1">schedule</i>-</span>`}
          </div>`;

          html += '</div>';
          tmpDrawFlowData[nodeId].html = html; // Aggiorno solo se il counter è impostato
        } else {
          let html = '<div><div class="title-box">' + step.data.name + ' </div>';
          html += `<div class="box-counter"> ${(parsedDate != null ? `<p>${parsedDate[0]}<br/><small>${parsedDate[1]}</small></p>` : `<p>0</p>`)}
           ${step.data.maxDurationSecs ? `<span class="badge badge-timeout float-right"><i class="mio vam mr-1">schedule</i>${this._timestampFormatPipe.transform(parseFloat((step.data.maxDurationSecs * 1000).toFixed(2)), 0)}` : `<span class="badge badge-timeout float-right"><i class="mio vam mr-1">schedule</i>-</span>`}
           </div>`;
          html += '</div>';
          tmpDrawFlowData[nodeId].html = html; // Aggiorno solo se il counter è impostato
        }

        // Poi controllo aggiungo le label alle connessioni
        // Per farlo devo ciclare i nodi, controllare se hanno input, su quegli input prendere il parent e controllare se parent e current ci sono nella mappa, se si aggiornare la connessione 
        if (this.inspectData.arcDurations && this.inspectData.arcDurations.length > 0) {
          let currentInputConnections = (step.inputs && step.inputs.input_1 && step.inputs.input_1.connections) ? step.inputs.input_1.connections : null;
          if (currentInputConnections != null) {
            currentInputConnections.forEach(connection => {

              const arcDuration = this.inspectData.arcDurations.find(arc =>
                arc.parentStepCode === this.getCodeByNodeId(connection.node) && arc.childStepCode === step.data.code
              );

              if (arcDuration) {
                const avgDurationSecs = arcDuration.avgDurationMs;
                let labelNode = '<span class="label label-warning" id="lb-b"><i class="mio vam mr-1">schedule</i>' + this._timestampFormatPipe.transform(parseFloat(avgDurationSecs.toFixed(2))) + '</span>';
                connection.labels = [labelNode];
              }

            });
            step.inputs.input_1.connection = currentInputConnections;
          }
        }
        delete tmpDrawFlowData['stats'];

        if (this.inspectData.instanceDuration.avgDurationMs > 0 && this.showInspectStats) {// Aggiungi le statistiche 
          let instanceDuration = this.inspectData.instanceDuration;
          let htmlStats = `
        <div>
            <div class="title-box">Stats</div>
            <div class="box p-0"> 
                <ul class="list-group d-flex">
                  <li class="list-group-item d-flex justify-content-between align-items-center">Instance Average Duration<br><b>${this._decimalPipe.transform(instanceDuration.avgDurationMs / 1000, '1.0-2')} secs (${this._timestampFormatPipe.transform(instanceDuration.avgDurationMs, 0)})</b></li>
                  <li class="list-group-item  d-flex justify-content-between align-items-center">Instance Minimum Duration<br><b>${this._decimalPipe.transform(instanceDuration.minDurationMs / 1000, '1.0-2')} secs (${this._timestampFormatPipe.transform(instanceDuration.minDurationMs, 0)})</b></li>
                  <li class="list-group-item  d-flex justify-content-between align-items-center">Instance Maximum Duration<br><b>${this._decimalPipe.transform(instanceDuration.maxDurationMs / 1000, '1.0-2')} secs (${this._timestampFormatPipe.transform(instanceDuration.maxDurationMs, 0)})</b></li>
              </ul>
            </div>
        </div>`;
          tmpDrawFlowData['stats'] = {
            id: 'stats',
            name: 'stats',
            data: {},
            class: 'stats',
            html: htmlStats,
            typenode: false,
            inputs: {},
            outputs: {},
            pos_x: -50,
            pos_y: 25
          }
        }

      }
    }

    const dataToImport = {
      drawflow: {
        Home: {
          data: tmpDrawFlowData
        }
      }
    };

    return dataToImport;
  }


  public layoutFlow(nodes) {
    // Recupera tutti gli step del flow
    const levels = {};

    // Funzione ricorsiva per assegnare il livello a ogni nodo
    function assignLevel(nodeId, level) {
      // Se il nodo ha già un livello assegnato e quello corrente non è superiore, esci
      if (levels[nodeId] !== undefined && levels[nodeId] >= level) return;
      levels[nodeId] = level;
      const node = nodes[nodeId];
      // Per ogni output del nodo, assegna il livello +1 ricorsivamente
      if (node.outputs) {
        for (const outputKey in node.outputs) {
          const output = node.outputs[outputKey];
          output.connections.forEach(conn => {
            assignLevel(conn.node, level + 1);
          });
        }
      }
    }

    // Trova gli step "radice" (senza parent) e inizia la traversata
    for (const nodeId in nodes) {
      if (!nodes[nodeId].data.parents || nodes[nodeId].data.parents.length === 0) {
        assignLevel(nodeId, 0);
      }
    }


    // Raggruppa i nodi per livello
    const sortedEntries = Object.entries(levels).sort((a, b) => (a as any)[1] - (b as any)[1]);

    // 2. Prepariamo l'oggetto che conterrà i gruppi
    const levelGroups: Record<number, string[]> = {};

    // 3. Iteriamo sull'array ORDINATO invece che sull'oggetto originale
    for (const [nodeId, lvl] of sortedEntries) {
      if (!levelGroups[(lvl as any)]) {
        levelGroups[(lvl as any)] = [];
      }
      levelGroups[(lvl as any)].push(nodeId);
    }

    const horizontalGap = 350; // Distanza tra colonne (X)
    const verticalGap = 180;   // Distanza tra nodi nella stessa colonna (Y)
    const OFFSET_X = 700;      // Punto di partenza globale X
    const OFFSET_Y = 700;      // Punto di partenza globale Y (asse centrale)

    // 1. Ordiniamo i livelli numericamente per evitare salti logici
    const sortedLvlKeys = Object.keys(levelGroups)
      .map(Number)
      .sort((a, b) => a - b);

    sortedLvlKeys.forEach((lvl) => {
      const nodesAtLevel = levelGroups[lvl];

      // 2. CALCOLO ALTEZZA COLONNA
      // Calcoliamo quanto è alta l'intera colonna per poterla centrare perfettamente
      const totalColumnHeight = (nodesAtLevel.length - 1) * verticalGap;

      nodesAtLevel.forEach((nodeId, index) => {
        let nodePosition = this.nodePositions[nodeId];

        // Se il nodo ha già una posizione salvata dall'utente, usiamola
        if (nodePosition && nodePosition.pos_x !== undefined && nodePosition.pos_y !== undefined) {
          nodes[nodeId].pos_x = nodePosition.pos_x;
          nodes[nodeId].pos_y = nodePosition.pos_y;
        } else {
          // 3. CALCOLO POSIZIONE X (Lineare per livello)
          nodes[nodeId].pos_x = (lvl * horizontalGap) + OFFSET_X;

          // 4. CALCOLO POSIZIONE Y (Centratura Automatica)
          // (index * verticalGap) ci dà la posizione nel gruppo
          // Sottraendo (totalColumnHeight / 2) spostiamo il centro del gruppo sullo 0
          // Aggiungendo OFFSET_Y portiamo tutto alla coordinata desiderata
          const centeredY = (index * verticalGap) - (totalColumnHeight / 2);
          nodes[nodeId].pos_y = centeredY + OFFSET_Y;
        }
      });
    });

    return nodes;
  }


  private addEditorEvents() {
    // Events!
    this.editor.on('nodeCreated', (id: any) => {
    });

    this.editor.on('nodeRemoved', (id: any) => {
      this.flowData = this.editor.export();
      this.drawFlowData = this.flowData.drawflow.Home.data;
      this.emitFlow(this.drawFlowData);
    });

    this.editor.on('nodeUnselected', (id: any) => {
      this.flowData = this.editor.export();
    });

    this.editor.on('nodeSelected', (id: any, graph: boolean = true) => {
      this.clickedOnGraph = graph;

      // Controlla se c'è closuresteps
      let code = this.editor.drawflow.drawflow.Home.data[id].data.code;
      if (this.closureSteps) {
        this.selectedStep = this.editor.drawflow.drawflow.Home.data[id];
        this.emitStep(this.selectedStep);
        setTimeout(() => {
          if (this.closureSteps.indexOf(code) >= 0) { // C'è 
            this.editor.node_selected.classList.add("step-closure");
          } else { // Non c'è 
            this.editor.node_selected.classList.remove("step-closure");
          }

          this.editor.node_selected.classList.remove("selected");
          this.editor.node_selected = null
          this.editor.dispatch('nodeUnselected', true);
        }, 50)
      } else {
        if (graph == true) {
          this.editor.drawflow.drawflow.Home.data[id].class = 'selected';
          this.selectedStep = this.editor.drawflow.drawflow.Home.data[id];
          this.emitStep(this.selectedStep);
          if (this.action == CrudActionType.TEST || this.action == CrudActionType.DETAILS) {
            this.onNodeDataLineageClick(this.selectedStep);
          }
        }
      }
    });

    /*this.editor.on('click', (e: any) => {
      console.log('Editor Event :>> Click :>> ', e); 
      if (this.closureSteps) {
        this.selectedStep = null;
        this.emitStep(this.selectedStep);

        if (e.target.closest('.drawflow_content_node') != null || e.target.classList[0] === 'drawflow-node') {
          this.selectedStep = new DrawFlowNode;
          if (e.target.closest('.drawflow_content_node') != null) {
            this.selectedStep.id = (e.target.closest('.drawflow_content_node').parentElement.id).slice(5);
          } else {
            this.selectedStep.id = e.target.id;
          }
          this.selectedStep = this.editor.getNodeFromId(this.selectedStep.id);
          this.emitStep(this.selectedStep);
        }
      }
    });*/

    this.editor.on('connectionCreated', (connection: any) => {
      this.flowData = this.editor.export();
      this.drawFlowData = this.flowData.drawflow.Home.data;
      this.emitFlow(this.drawFlowData);
    });

    this.editor.on('connectionRemoved', (connection: any) => {
      this.flowData = this.editor.export();
      this.drawFlowData = this.flowData.drawflow.Home.data;
      this.emitFlow(this.drawFlowData);
    });


  }

  public convertNodeToStepType(node: any): DrawFlowNode {
    return node.data;
  }


  emitStep(step: DrawFlowNode) {
    this.stepEmitted.emit(step);
  }

  emitFlow(drawFlowData: DrawFlowDto) {
    this.flowEmitted.emit(drawFlowData);
  }

  public getNodeByCode(code: string): DrawFlowNode {
    return Object.values(this.drawFlowData).filter(item => item.data.code === code)[0];
  }

  public getCodeByNodeId(nodeId: DrawFlowNode['id']): string {
    return this.drawFlowData[nodeId].data.code;
  }



  // INSPECT
  onNodeDataLineageClick(node: DrawFlowNode) {
  }

  ngOnInit(): void {
    if (this._bowmanCacheService.has('algorilla_user')) {
      this._bowmanCacheService.get('algorilla_user').subscribe(user => {
        this.user = user;
        if (this.action == this.crudActionTypes.EDIT) {
          this.locked = false;
        }

      });
    } else {
      this.user = null;
      this._notificationsService.error('Cannot get user information');
    }
  }

  ngAfterViewInit() {
    this.initDrawFlow();
    this.addEditorEvents();
    this.flowData = this.initializeDrawflow(this.drawFlowData);
    setTimeout(() => {
      this.editor.translate_to(-675, -675);
      this.calcDrawFlowHeight();
      this.rearrangeFlow();
    }, 250)
  }

  calcDrawFlowHeight(): void {
    var drawFlowHtmlElement = document.getElementById('drawflow-' + this.drawflowId);
    if (drawFlowHtmlElement && drawFlowHtmlElement.parentElement && drawFlowHtmlElement.parentElement.parentElement && drawFlowHtmlElement.parentElement.parentElement.offsetHeight) {
      drawFlowHtmlElement.style.height = `${drawFlowHtmlElement.parentElement.parentElement.offsetHeight + 500}px`;
    }
  }

  rearrangeFlow(): void {
    let arrangedData = this.layoutFlow(this.flowData.drawflow.Home.data);
    this.flowData.drawflow.Home.data = arrangedData;
    this.editor.import(this.flowData);
  }


  ngOnChanges(changes: SimpleChanges): void {
    // Ad ogni aggiornamento del drawFlowData ricevi e converti
    Object.keys(changes).filter(propName => propName == 'drawFlowData').map(propName => {
      const change: SimpleChange = changes[propName];
      if (change.previousValue != undefined) {
        if (JSON.stringify(change.currentValue) != JSON.stringify(change.previousValue)) {
          this.drawFlowData = change.currentValue;
          let oldDrawFlowData = this.editor.export();

          for (const [nodeId, nodeData] of Object.entries(this.drawFlowData)) {

            if (oldDrawFlowData[nodeId] && oldDrawFlowData[nodeId].pos_x != nodeData.pos_x) {
              nodeData.pos_x = oldDrawFlowData[nodeId].pos_x;
            } else {
              if (nodeData.pos_x < 700) {
                nodeData.pos_x = nodeData.pos_x + 700;
              }
            }

            if (oldDrawFlowData[nodeId] && oldDrawFlowData[nodeId].pos_y != nodeData.pos_y) {
              nodeData.pos_y = oldDrawFlowData[nodeId].pos_y;
            } else {
              if (nodeData.pos_y < 700) {
                nodeData.pos_y = nodeData.pos_y + 700;
              }
            }

            this.nodePositions[nodeId] = {
              pos_x: nodeData.pos_x,
              pos_y: nodeData.pos_y,
            };
            console.log(nodeData.name + ': ' + JSON.stringify(this.nodePositions[nodeId]));
          }

          this.flowData = this.initializeDrawflow(this.drawFlowData);
          this.rearrangeFlow();
        }
      }
    });

    Object.keys(changes).filter(propName => propName == 'selectedStep').map(propName => {
      const change: SimpleChange = changes[propName];

      if (change.previousValue != null && change.currentValue != null) {
        // Se è stato selezionato un nuovo step, aggiorna il flow
        if (change.currentValue.html != change.previousValue.html && JSON.stringify(change.currentValue.data) != JSON.stringify(change.previousValue.data)) {
          if (this.clickedOnGraph != true) {
            this.flowData = this.initializeDrawflow(this.drawFlowData);
            this.rearrangeFlow();
          } else {
            this.clickedOnGraph = false;
            //this.editor.dispatch('nodeSelected', change.previousValue.id);
            //this.flowData = this.initializeDrawflow(this.drawFlowData);
            //this.editor.import(this.flowData);
          }
        }

      } else {
        // Primo nodo selezionato
        if (change.currentValue != null && this.clickedOnGraph != true) {
          setTimeout(() => {
            this.flowData = this.initializeDrawflow(this.drawFlowData);
            this.rearrangeFlow();
          }, 50)
        }
      }


    });

    Object.keys(changes).filter(propName => propName == 'closureSteps').map(propName => {
      const change: SimpleChange = changes[propName];
      if (change.firstChange == false) {
        if (JSON.stringify(change.currentValue) != JSON.stringify(change.previousValue)) {
          setTimeout(() => {
            this.closureSteps = change.currentValue;
            this.flowData = this.initializeDrawflow(this.drawFlowData);
            this.editor.import(this.flowData);
          }, 50);
        }
      }
    });

    Object.keys(changes).filter(propName => propName == 'inspectData').map(propName => {
      const change: SimpleChange = changes[propName];
      if (change.currentValue && JSON.stringify(change.currentValue) != JSON.stringify(change.previousValue)) {
        setTimeout(() => {
          this.flowData = HelperFunctions.clone(this.flowData);
          this.flowData = this.initializeDrawflow(this.drawFlowData);
          this.rearrangeFlow();
        }, 50)
      }
    });
  }

}
